import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import BedrockVerify from './bedrock';
import FsmVerify from './fsm';

const Verify = () => {
  const { isBedrock } = useAuthenticatedContextProvider();

  if (isBedrock) {
    return <BedrockVerify />;
  }

  return <FsmVerify />;
};

export default Verify;
